import axios from 'axios';
import { ajaxUri } from '../../../consts/index';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { l } from '../../../functions';

export const fetchPayloads = (loadIncrement = null,target = null) => {
    return dispatch => {
        if( target !== null ){
            const arrayTarget = Array.isArray(target) ? target:[target];

            axios({
                method: 'post',
                url: ajaxUri,
                data: {
                    request : 'getPayload',
                    target : arrayTarget
                }
            })
            .then(result => {
                if( loadIncrement ) dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)});

                for (const mytarget of arrayTarget) dispatch({type:'LIST_PAYLOAD',target:mytarget,value:JSON.parse(result.data[mytarget])})
            }).catch(error => {
                console.error(l('Cannot load payloads'))
            });
        }
    }
}

export const setPayload = (index = null,value = null) => {
    return dispatch => {
        if( index && value ){
            dispatch({type:'LIST_PAYLOAD',target:index,value:value});
        }
    }
}

export const updatePayloadHistory = (payload = []) => {
    return dispatch => {
        dispatch({type:'UPDATE_PAYLOADHISTORY',payload:payload});
    }
}

export const clearHistory = () => {
    return dispatch => {
        dispatch(UndoActionCreators.clearHistory());
    }
}

export const setHistorying = (bool) => {
    return dispatch => {
        dispatch({type:'HISTORYING',bool:bool});
    }
}